import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import {
    Modal,
    Form,
    Input,
    Select,
    Button,
    Spin,
    Space
} from "antd";

import {
    BookOutlined,
    ApartmentOutlined
} from "@ant-design/icons";

import api from "../../../api/api";


const { Option } = Select;


const SubjectFormModal = ({
    open,
    handleClose,
    onSubjectCreated
}) => {


    const [form] = Form.useForm();

    const [divisions, setDivisions] = useState([]);

    const [loading, setLoading] = useState(false);

    const token = localStorage.getItem("access");



    const fetchDivisions = async () => {

        try {

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };


            const response = await api.get(
                "api/users/divisions/",
                config
            );


            setDivisions(response.data);


        } catch(error){

            console.log(
                "Division loading error:",
                error
            );

        }

    };




    useEffect(()=>{

        if(open){
            fetchDivisions();
        }

    },[open]);





    const handleSubmit = async(values)=>{


        setLoading(true);


        try{


            const config = {
                headers:{
                    Authorization:`Bearer ${token}`
                }
            };


            await api.post(
                "api/users/subjects/",
                {
                    name:values.name,
                    division_assigned:values.division
                },
                config
            );



            Swal.fire({

                icon:"success",

                title:"Subject Created",

                text:"The subject has been added successfully.",

                timer:1800,

                showConfirmButton:false

            });



            form.resetFields();


            onSubjectCreated?.();


            handleClose();



        }catch(error){


            console.log(error);


            Swal.fire({

                icon:"error",

                title:"Creation Failed",

                text:
                error.response?.data?.detail ||
                "Unable to create subject."

            });



        }finally{


            setLoading(false);

        }

    };






    return (

        <Modal

            title={
                <Space>
                    <BookOutlined />
                    Create New Subject
                </Space>
            }

            open={open}

            onCancel={handleClose}

            footer={null}

            centered

            width={450}


        >


            <Form

                form={form}

                layout="vertical"

                onFinish={handleSubmit}

            >



                <Form.Item

                    label="Subject Name"

                    name="name"

                    rules={[
                        {
                            required:true,
                            message:
                            "Please enter subject name"
                        }
                    ]}

                >

                    <Input

                        size="large"

                        prefix={<BookOutlined/>}

                        placeholder="Example: Mathematics"

                        disabled={loading}

                    />


                </Form.Item>





                <Form.Item

                    label="Assign Division"

                    name="division"

                    rules={[
                        {
                            required:true,
                            message:
                            "Please select division"
                        }
                    ]}


                >


                    <Select

                        size="large"

                        showSearch

                        placeholder="Select division"

                        optionFilterProp="children"

                        suffixIcon={<ApartmentOutlined/>}

                        disabled={loading}


                    >


                        {
                            divisions.map((division)=>(

                                <Option

                                    key={division.id}

                                    value={division.id}

                                >

                                    {division.name}

                                </Option>

                            ))
                        }


                    </Select>


                </Form.Item>






                <Space

                    style={{
                        width:"100%",
                        justifyContent:"flex-end"
                    }}

                >


                    <Button

                        onClick={handleClose}

                        disabled={loading}

                    >

                        Cancel

                    </Button>



                    <Button

                        type="primary"

                        htmlType="submit"

                        disabled={loading}

                    >


                        {
                            loading ?

                            <Spin size="small"/>

                            :

                            "Create Subject"
                        }


                    </Button>


                </Space>



            </Form>


        </Modal>

    );

};


export default SubjectFormModal;